{
  "(optional)": "(pasirenkama)",
  "(required)": "(privaloma)"
}